import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Columns } from '@dixa/lib-shared-habla';
import { useLocation } from 'react-router-dom';
import { Menu } from 'components/settings/components/menu';
import { useBreakpointValue } from 'utils/mediaQuery';
/** Represents the settings view. */
export const SettingsView = ({ children }) => {
    const location = useLocation();
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const showSettingsMenu = !/\/flow\/(?!.*history)/g.test(location.pathname);
    return (_jsxs(Columns, Object.assign({ className: "settings-page" }, { children: [showSettingsMenu && (_jsx(Column, Object.assign({ size: isSmallScreen ? menuWidths[0] : menuWidths[1] }, { children: _jsx(Column.Row, Object.assign({ scrollable: true, noHorizontalPadding: true, noVerticalPadding: true, style: {
                        '--menu-width-collapsed': menuWidths[0],
                        '--menu-width-expanded': menuWidths[1],
                    } }, { children: _jsx(Menu, {}) })) }))), _jsx(Column, Object.assign({ size: "3fr" }, { children: children }))] })));
};
const menuWidths = ['68px', '258px'];
